export const DashboardConstants = {
    endpoint: {
        defaultFlow: '/logchain-admin/default-flow/step',
        flow: '/compliance/flow/step',
        flowsValidate: '/compliance/flows-validate/step',
    },
};
